import { SummaryDisplayFeatureList } from '~shared/types/pricing/features';
import { FeatureSetMap, FeatureMapItem } from '../types';
import {
  SummaryFeatureRuleMap,
  FeatureTransformerOptions,
  SummaryFeatureTransformer,
  SummaryFeatureList,
} from './types';

import SummaryFeatureMap from './summaryFeatureMap';

export default function summaryFeaturesTransformer(
  featureList: SummaryFeatureList,
  featureListRules: SummaryFeatureRuleMap
): SummaryFeatureTransformer {
  return (packageFeatures: FeatureSetMap, options: FeatureTransformerOptions): SummaryDisplayFeatureList =>
    featureList.map((featureListItem: string) => {
      const featureItem: FeatureMapItem =
        SummaryFeatureMap.find(item => item?.featureItemKey === featureListItem) ?? null;

      if (featureItem) {
        // if the features are empty , push the key inside the feature array based on the rule mapping
        // See src/app/pages/Pricing/transformers/summary/featureRules.ts
        const featureKeys: string[] = featureItem?.features ?? [featureItem.featureItemKey];

        // map the feature keys with the defined package features
        const featureValues = featureKeys.reduce(
          (acc: FeatureSetMap, featureKey: string) => ({
            ...acc,
            [featureKey]: packageFeatures[featureKey],
          }),
          {}
        );
        // apply the proper rule for this display feature
        return featureListRules[featureItem.featureItemKey](featureValues, options);
      }
      return null;
    });
}
